import { parseTextMaxLength } from '../../../../components/FormComponents/utils/functions';
import { EntityInfoFormData } from '../../../../state/enrollment/enrollmentModel';

export const parseCIK = (value: string) =>
  parseTextMaxLength(value.replace(/\D/g, ''), 10);
export const parseCCCPassphrase = (value: string) =>
  parseTextMaxLength(value, 8);

export const validateEntityInfoForm = (values: EntityInfoFormData) => {
  const errors: any = {};
  const cccPassphraseRegex = /^(?=.*\d)(?=.*[@#$*]).{8}$/;

  if (!values.cik) {
    errors.cik = 'CIK cannot be empty';
  }
  if (!values.ccc) {
    errors.ccc = 'CCC cannot be empty';
  } else if (!cccPassphraseRegex.test(values.ccc)) {
    errors.ccc = 'CCC is not formatted correctly';
  }
  if (!values.passphrase) {
    errors.passphrase = 'Passphrase cannot be empty';
  } else if (!cccPassphraseRegex.test(values.passphrase)) {
    errors.passphrase = 'Passphrase is not formatted correctly';
  }

  return errors;
};
